import { TextMorph } from '@/components/core/text-morph';
import { AnimatePresence, motion } from 'motion/react';

const iconTransition = {
  type: 'spring',
  stiffness: 280,
  damping: 18,
  mass: 0.3,
};

const iconVariants = {
  initial: { opacity: 0, scale: 0.82 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.82 },
};

function PlayIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
      <path
        d="M3.33333 3.51579C3.33333 2.37788 4.55073 1.65434 5.55025 2.1982L13.7913 6.68233C14.8354 7.2504 14.8354 8.74933 13.7913 9.31747L5.55025 13.8016C4.55073 14.3454 3.33333 13.6219 3.33333 12.484V3.51579Z"
        fill="currentColor"
      />
    </svg>
  );
}

function StopIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
      <path
        d="M3.16667 2C2.52233 2 2 2.52233 2 3.16667V12.8333C2 13.4777 2.52233 14 3.16667 14H12.8333C13.4777 14 14 13.4777 14 12.8333V3.16667C14 2.52233 13.4777 2 12.8333 2H3.16667Z"
        fill="currentColor"
      />
    </svg>
  );
}

/**
 * @param {{
 *   playing: boolean;
 *   disabled?: boolean;
 *   onToggle: () => void;
 * }} props
 */
export function IntroPlayStopButton({ playing, disabled = false, onToggle }) {
  return (
    <button
      type="button"
      id="intro-play-stop"
      className="intro-play-stop"
      data-state={playing ? 'playing' : 'paused'}
      aria-pressed={playing}
      disabled={disabled}
      onClick={onToggle}
    >
      <span className="intro-play-stop__icon" aria-hidden="true">
        <AnimatePresence mode="popLayout" initial={false}>
          {playing ? (
            <motion.span
              key="stop"
              className="intro-play-stop__icon-motion"
              initial="initial"
              animate="animate"
              exit="exit"
              variants={iconVariants}
              transition={iconTransition}
            >
              <StopIcon />
            </motion.span>
          ) : (
            <motion.span
              key="play"
              className="intro-play-stop__icon-motion"
              initial="initial"
              animate="animate"
              exit="exit"
              variants={iconVariants}
              transition={iconTransition}
            >
              <PlayIcon />
            </motion.span>
          )}
        </AnimatePresence>
      </span>
      <TextMorph as="span" className="intro-play-stop__label">
        {playing ? 'Stop' : 'Play'}
      </TextMorph>
    </button>
  );
}
